import {Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { UploadFileModel } from '../upload-file.model';
import { ResponseWorkflowService } from 'src/app/core-api/services/responses/response-workflow.service';
import { CODE_WORKFLOW_COMPONENT } from 'src/app/app.models';

@Component({
    selector: 'abw-upload-file-result',
    templateUrl: './upload-file-result.component.html',
    styleUrls: ['./upload-file-result.component.scss']
})
export class UploadFileResultComponent implements OnInit, OnChanges {
	@Input() model: UploadFileModel;
    @Input() value: string;
    filename: string = null;

    constructor(
        private _responseWorkflowService: ResponseWorkflowService
    ) {
    }

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!!changes.value && !!changes.value.currentValue) {
            this.filename = this.value.substring(this.value.lastIndexOf('\\') + 1);
        }
    }

    async doDownloadFile() {
        await this._responseWorkflowService.doDownloadResponseWorkflowFile(CODE_WORKFLOW_COMPONENT.UPLOAD_FILE, this.value);
    }
}